import React from 'react';

export const UploadFiles = ({ uploadFileBoxes }) => {
    return (
        <div className="documents__blocks">
            <div className="documents__block form-files">
                <div className="row form-files-container">{uploadFileBoxes.map(({ component }) => component)}</div>
            </div>
        </div>
    );
};
